module.exports = __webpack_public_path__ + "assets/boomerang.gif";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang.gif
// module id = 565
// module chunks = 0